module.exports = __webpack_public_path__ + "media/images/pc/stores/fukuoka/fukuoka_concept_03-d3eeb96cae6e14e1c859368fd232ba3b.jpg";